import type {
  UpdateLineItemApprovedResponse,
  UpdateLineItemApprovedVariables,
} from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { vestigasApi } from '~/services/kyClient';

import {
  zodUpdateLineItemApprovedPayloadSchema,
  zodUpdateLineItemApprovedResponseSchema,
} from './validations';

/**
 * Updates approved values on an invoice line item.
 *
 * @param variables - Invoice, line-item, and approved values to update.
 * @returns The updated invoice detail.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoices/operation/update_line_item_approved_invoices__invoice_id__line_items__line_item_id__approved_patch
 */
export async function updateLineItemApproved({
  invoiceId,
  lineItemId,
  payload,
}: UpdateLineItemApprovedVariables): Promise<UpdateLineItemApprovedResponse> {
  // Parsing the response here would turn schema drift into a failed edit after
  // the write has already succeeded.
  return await vestigasApi
    .patch(ENDPOINT.INVOICE.UPDATE_LINE_ITEM_APPROVED(invoiceId, lineItemId), {
      json: payload,
      validate: {
        body: zodUpdateLineItemApprovedPayloadSchema,
        response: zodUpdateLineItemApprovedResponseSchema,
      },
    })
    .json<UpdateLineItemApprovedResponse>();
}
